import React from 'react';

import { PlainTextEditor } from '../../../PlainTextEditor';
import type { PlainTextEditorProps } from '../../../PlainTextEditor';

// Styles are authored in `Profile.scss`

export type DescriptionProps = Pick<
    PlainTextEditorProps,
    | 'placeholder'
    | 'value'
    | 'editMode'
    | 'characterLimit'
    | 'editing'
    | 'onEnableEditing'
    | 'onDisableEditing'
    | 'onUpdateValue'
    | 'onChange'
>;

export const PROFILE_DESCRIPTION_ID = 'Profile-Description';
export const PROFILE_DESCRIPTION_ID_EDITABLE = 'Profile-Description-Editable';

export function Description({
    placeholder,
    characterLimit,
    value,
    editMode,
    editing,
    onEnableEditing,
    onDisableEditing,
    onUpdateValue,
    onChange,
}: DescriptionProps) {
    return (
        <div id={PROFILE_DESCRIPTION_ID} className="Yat_Profile-Description">
            <PlainTextEditor
                id={PROFILE_DESCRIPTION_ID_EDITABLE}
                placeholder={placeholder}
                value={value}
                editMode={editMode}
                editing={editing}
                characterLimit={characterLimit}
                onChange={onChange}
                onEnableEditing={onEnableEditing}
                onDisableEditing={onDisableEditing}
                onUpdateValue={onUpdateValue}
            />
        </div>
    );
}
